import React from "react";

export const KeywordSearch = React.lazy(
  () => import("@/features/keyword-search/pages/KeywordSearchPage"),
);
